export default class Breadcrumb {
  constructor() {
    this.setEvent();
    this.render();
  }

  setEvent() {
    if (TMON.view_mode === 'app') {
      $('body').on('click', '#_bread1 a[data-role=goHome]', this.goHome);
      $('body').on(
        'click',
        '#_bread1 a[data-role=goCategory]',
        this.goCategory
      );
    }
  }

  clearEvent() {
    if (TMON.view_mode === 'app') {
      $('body').off('click', '#_bread1 a[data-role=goHome]');
      $('body').off('click', '#_bread1 a[data-role=goCategory]');
    }
  }

  /**
   * 브레드크럼스의 '홈' 앵커가 동작했을 때 액션. 앱일 경우 콜앱을 실행하기 위한 함수 (웹일 경우 a[href] 링크이동)
   * @param {object} e event 객체
   */
  goHome(e) {
    TMON.app.callApp('webview', 'goHome');
    e.preventDefault();
  }

  /**
   * 브레드크럼스의 카테고리 앵커가 동작했을 때 액션. 앱일 경우 콜앱을 실행하기 위한 함수 (웹일 경우 a[href] 링크이동)
   * @param {object} e event 객체
   */
  goCategory(e) {
    const sSelectedCategoryNo = $(e.currentTarget).attr('data-no');
    const nSelectedCategoryNo = parseInt(sSelectedCategoryNo, 10);
    TMON.app.callApp('event', 'goDetailCategory', nSelectedCategoryNo);
    e.preventDefault();
  }

  render() {
    const { htCategoryInfo } = TMON.oApp.htStorage.htStaticData;

    const sTemplate = `<div>
                <a href="${
                  TMON.htLocal.htURL.www_php_m
                }" data-role="goHome" data-no="홈" data-tlarea="BRCR" data-tlord="1">홈</a>
                ${htCategoryInfo.sDepth1No &&
                  `<a href="${TMON.htLocal.htURL.www_m_dealList}${htCategoryInfo.sDepth1No}" data-role="goCategory" data-no="${htCategoryInfo.sDepth1No}" data-tlarea="BRCR" data-tlord="2">${htCategoryInfo.sDepth1Title}</a>`}
                ${htCategoryInfo.sDepth2No &&
                  `<a href="${TMON.htLocal.htURL.www_m_dealList}${htCategoryInfo.sDepth2No}" data-role="goCategory" data-no="${htCategoryInfo.sDepth2No}" data-tlarea="BRCR" data-tlord="3">${htCategoryInfo.sDepth2Title}</a>`}
                ${htCategoryInfo.sDepth3No &&
                  `<a href="${TMON.htLocal.htURL.www_m_dealList}${htCategoryInfo.sDepth3No}" data-role="goCategory" data-no="${htCategoryInfo.sDepth3No}" data-tlarea="BRCR" data-tlord="4">${htCategoryInfo.sDepth3Title}</a>`}
                ${htCategoryInfo.sDepth4No &&
                  `<a href="${TMON.htLocal.htURL.www_m_dealList}${htCategoryInfo.sDepth4No}" data-role="goCategory" data-no="${htCategoryInfo.sDepth4No}" data-tlarea="BRCR" data-tlord="5">${htCategoryInfo.sDepth4Title}</a>`}
            </div>`;
    $('#_bread1').html(sTemplate);
  }
}
